import React from 'react';
import PropTypes from 'prop-types';

import Spinner from '../../Loaders/Spinner';

const ModalPreloader = ({ isLoading, children }) => {
  if (isLoading) {
    return (
      <div className="modal-body">
        <Spinner />
      </div>
    );
  }
  return children;
};

ModalPreloader.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.any,
};

export default ModalPreloader;
